import { clearAdminPermissions, setAdminPermissions, setGcopEnabled } from '@/storage/adminStorage';

export default {
    setToken(state, payload) {
        state.token = payload
        localStorage.setItem("token", payload)
    },
    clearToken(state) {
        state.token = null
        localStorage.removeItem("token")
    },
    changeLayoutMode(state, payload) {
        state.layoutMode = payload;
        localStorage.setItem("layoutMode", payload);
    },
    setGcop(state, value) {
        state.gcop = value;
        setGcopEnabled(value);
    },
    setAdminPermissions(state, permissions) {
        state.adminPermissions = Array.isArray(permissions) ? permissions : [];
        setAdminPermissions(state.adminPermissions);
    },
    clearAdminPermissions(state) {
        state.adminPermissions = [];
        clearAdminPermissions();
    },
};
